/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState, useCallback, SetStateAction} from 'react'
import clsx from 'clsx'
import {
  MessageModel,
  UserInfoModel,
} from '../../helpers'
import { i18n } from '../../../app/translate/i18n'
import { POST } from '../../../app/services/api'
import { rtcToText } from '../../../app/utils/formater'
import { useVoiceControl } from '../../../app/hooks/useVoiceControl'
import { useSpeechSynthesis } from '../../../app/hooks/useSpeechSynthesis'
import styles from './ChatInner.module.css'

type Props = {
  isDrawer?: boolean
  message: string
  setMessage: React.Dispatch<React.SetStateAction<string>>
  isVoiceOn: boolean
  speak?: (text: string) => void 
}

type LocalSavedMessageType = {
  lastMessage: Date,
  messages: MessageModel[],
  sessionId: string;
}

const ChatInner: FC<Props> = ({
  isDrawer = false,
  message,
  setMessage,
  isVoiceOn,
  speak
}) => {
  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [messages, setMessages] = useState<MessageModel[]>([{
    user: 0,
    type: 'in',
    text: i18n.t(`chat.initial_message`),
    time: new Date().getTime()
  }])
  const [userInfos] = useState<UserInfoModel[]>([
    {
      name: 'Ninegrid',
      avatar: 'avatars/300-6.jpg',
    },
    {
      name: i18n.t(`chat.you`),
      avatar: 'avatars/300-6.jpg',
    }
  ])
  const textbox = useRef(null);
  useSpeechSynthesis();
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [messageLoading, setMessageLoading] = useState<MessageModel>({
    user: 0,
    type: 'in',
    text: '...',
  })

  const sendMessage = useCallback((type: 'in' | 'out', user: number, messageReceived?: string) => {
    const newMessages = [...messages];
    const newMessage: MessageModel = {
      user: user,
      type: type,
      text: messageReceived ? messageReceived : message,
      time: new Date().getTime(),
    };
    newMessages.push(newMessage);
    setMessages(newMessages);
    toggleChatUpdate();
    if (type === 'out') {
      sendMessageNinegridIA(message, newMessages);
      setMessage('');
    }
  }, [message, messages, setMessage]);

  const handleVoiceMessage = useCallback((text: string) => {
  console.log('handleVoiceMessage recebeu:', text); 
  const sendCommands = [
    'enviar agora',
    'enviar mensagem',
    'envie agora',
    'mandar mensagem',
    'encaminhar mensagem',
    'mandar agora',
    'enviando agora'  // Adicionado novo comando
  ];

  const normalizedText = text.toLowerCase().trim();
  console.log('Texto reconhecido:', normalizedText);
  
  // Verifica se é um comando de envio
  if (sendCommands.some(cmd => normalizedText.includes(cmd))) {
    console.log('Comando de envio reconhecido!');
    if (message.trim()) {
      console.log('Enviando mensagem atual:', message);
      sendMessage('out', 1);
      return true;
    }
  } else {
    // Se não for comando, concatena com o texto existente
    setMessage(prev => {
      const newText = prev ? `${prev} ${text}` : text;
      console.log('Novo texto concatenado:', newText);
      return newText;
    });
  }
  
  return false;
}, [message, sendMessage, setMessage]);

   useVoiceControl({
    setMessage: useCallback((text: SetStateAction<string>) => {
      console.log('setMessage do ChatInner recebeu:', text);
      if (typeof text === 'string') {
        handleVoiceMessage(text);
      }
    }, [handleVoiceMessage])
  });
  
  const utf8_to_b64 = (str: string) => {
    try {
      return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode(Number('0x' + p1));
        }));
    } catch (e) {
      console.error('Erro na codificação:', e);
      return '';
    }
  }

  const b64_to_utf8 = (str: string) => {
    try {
      return decodeURIComponent(window.atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    } catch (e) {
      console.error('Erro na decodificação:', e);
      return '';
    }
  }

  

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      if(message) {
        if (typeof window !== 'undefined') {
          const event = new Event('stopRecording');
          window.dispatchEvent(event);
        }
        sendMessage('out', 1)
      }
    }
  }

  const getTimeDifference = (timeMessage: number) => {
    const dateMsg = new Date(timeMessage);
    const today = new Date()
    const timeNow = today.getTime();
    const timeMinutes = Math.trunc((timeNow - timeMessage)/60000)
    return  timeMinutes <= 0 ? 
              i18n.t(`chat.now`) : 
              today.toLocaleDateString() === dateMsg.toLocaleDateString() ? 
                dateMsg.toLocaleTimeString().substring(0, 5) : 
                `${dateMsg.toLocaleDateString()} ${dateMsg.toLocaleTimeString().substring(0, 5)}`
  }

  const animateMessageLoading = () => {
    const now = new Date().getTime() / 300;
    switch(Math.trunc(now % 3)) {
      case 0:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '.'
        });
        break;
      case 1:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '..'
        });
        break;
      case 2:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '...'
        });
        break;
      default:
        setMessageLoading({
          user: 0,
          type: 'in',
          text: '...'
        });
        break;
    }
  }

  const sendMessageNinegridIA = async (messageToSend: string, newMessages: MessageModel[]) => {
    try {
      setLoading(true);
      let messageLanguage = i18n.t(`chat.tip_language`);
      
      const res = await POST(`/chatIA/question`, {
        inputText: messageToSend + ' ' + messageLanguage,
        sessionId
      });
      
      setLoading(false);
      let newSessionId = sessionId;
      let messageIA = '';

      if (res.success && res.data.response && res.data.completion && res.data.response.sessionId) {
        messageIA = res.data.completion;
        setSessionId(res.data.response.sessionId);
        newSessionId = res.data.response.sessionId;
        
        if (isVoiceOn && speak && messageIA.trim()) {
          speak(messageIA);
        }
      } else {
        messageIA = i18n.t(`chat.error_message`);
      }

      const newMessage: MessageModel = {
        user: 0,
        type: 'in',
        text: messageIA,
        time: new Date().getTime(),
      };

      newMessages.push(newMessage);
      setMessages(newMessages);
      saveLocalMessages(newMessages, newSessionId);
      toggleChatUpdate();
      scrollToBottm();

    } catch(e) {
      console.error('Erro ao enviar mensagem:', e);
      setLoading(false);
      
      const newMessage: MessageModel = {
        user: 0,
        type: 'in',
        text: i18n.t(`chat.error_message`),
        time: new Date().getTime(),
      };
      
      newMessages.push(newMessage);
      setMessages(newMessages);
      saveLocalMessages(newMessages, sessionId);
      toggleChatUpdate();
    }
  };

  const toggleChatUpdate = () => {
    toggleChatUpdateFlat(!chatUpdateFlag)
    setTimeout(() => {
      toggleChatUpdateFlat((flag) => !flag)
    }, 1000)
  }

  const saveLocalMessages = (newMessages: MessageModel[], newSessionId: string) => {
    try {
      const data = {
        lastMessage: new Date(),
        messages: newMessages,
        sessionId: newSessionId
      };
      localStorage.setItem(
        utf8_to_b64('messagesIA'), 
        utf8_to_b64(JSON.stringify(data))
      );
    } catch (e) {
      console.error('Erro ao salvar mensagens:', e);
    }
  }

  const adjustHeightTextArea = () => {
    if(textbox && textbox.current){
      const styleTextbox:any = textbox.current
      if(styleTextbox.scrollHeight <= 130){
        styleTextbox.style.height = "inherit";
        styleTextbox.style.height = `${styleTextbox.scrollHeight}px`;
        const divChat = document.getElementById('chat-scroll');
        const divFooter = document.getElementById('kt_drawer_chat_messenger_footer');
        if(divChat && divFooter){
          divChat.style.height = `${80 - ((styleTextbox.scrollHeight - 50)/7)}%`
          divChat.style.paddingBottom = `calc(${20 + ((styleTextbox.scrollHeight - 50)/7)}% + ${window.innerHeight/12}px)`
          divFooter.style.height = `calc(${20 + ((styleTextbox.scrollHeight - 50)/7)}% - 2.5em)`
        }
      }
    }
  }

  const scrollToBottm = () => {
    const divChat = document.getElementById('kt_drawer_chat')
    if(divChat){
      divChat.scrollTo(0, divChat.scrollHeight)
    }
  }

  useEffect(() => {
    const messagesIALocal = localStorage.getItem(utf8_to_b64('messagesIA'));
    
    if(messagesIALocal){
      try {
        const messageLocalSaved: LocalSavedMessageType = JSON.parse(b64_to_utf8(messagesIALocal));
        
        if(
          messageLocalSaved && 
          messageLocalSaved.lastMessage && 
          messageLocalSaved.messages && 
          messageLocalSaved.sessionId
        ){
          if((new Date().getTime() - new Date(messageLocalSaved.lastMessage).getTime()) < (1000 * 60 * 60 * 24)){
            setMessages(messageLocalSaved.messages);
            setSessionId(messageLocalSaved.sessionId);
          } else {
            localStorage.removeItem(utf8_to_b64('messagesIA'));
          }
        }
      } catch (e) {
        console.error('Erro ao carregar mensagens:', e);
        localStorage.removeItem(utf8_to_b64('messagesIA'));
      }
    }
    
    setInterval(() => {
      animateMessageLoading();
    }, 300);
  }, []);

  useEffect(() => {
        scrollToBottm()
      },[messages])

    useEffect(() => {
      // Handler para comandos de voz
      const handleVoiceCommand = (e: CustomEvent) => {
        if (e.detail.type === 'send' && message.trim()) {
          console.log('Executando comando de envio por voz');
          sendMessage('out', 1);
        }
      };

      // Adiciona o listener
      window.addEventListener('voiceCommand', handleVoiceCommand as EventListener);

      // Cleanup
      return () => {
        window.removeEventListener('voiceCommand', handleVoiceCommand as EventListener);
      };
  }, [message, sendMessage]);


  return (
    <div
      className={styles.chatBody}
      id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
    >
      
      <div
        id='chat-scroll'
        className={styles.chatInner}
        style={{paddingBottom: `calc(20% + ${window.innerHeight/12}px)`}}
        data-kt-element='messages'
        data-kt-scroll='true'
        data-kt-scroll-activate='{default: false, lg: true}'
        data-kt-scroll-dependencies={
          isDrawer
            ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
            : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
        }
        data-kt-scroll-wrappers={
          isDrawer ? '#kt_drawer_chat_messenger_body' : '#kt_content, #kt_chat_messenger_body'
        }
        data-kt-scroll-offset={isDrawer ? '0px' : '-2px'}
      >
        {
          [...messages, loading ? messageLoading : null].map((message, index) => {
            if(message){
              const userInfo = userInfos[message.user]
              const state = message.type === 'in' ? 'info' : 'primary'
              const templateAttr = {}
              if (message.template) {
                Object.defineProperty(templateAttr, 'data-kt-element', {
                  value: `template-${message.type}`,
                })
              }
              const contentClass = `${isDrawer ? '' : 'd-flex'} justify-content-${
                message.type === 'in' ? 'start' : 'end'
              } mb-10`
              return (
                <div
                  key={`message${index}`}
                  className={clsx('d-flex', contentClass, 'mb-10', {'d-none': message.template})}
                  {...templateAttr}
                >
                  <div
                    className={clsx(
                      'd-flex flex-column align-items',
                      `align-items-${message.type === 'in' ? 'start' : 'end'}`
                    )}
                  >
                    <div className='d-flex align-items-center mb-2'>
                      {message.type === 'in' ? (
                        <>
                          <div className='ms-3'>
                            <a
                              href='#'
                              className='fs-5 fw-bolder text-gray-900 text-hover-primary me-1'
                            >
                              {userInfo.name}
                            </a>
                            <span className='text-muted fs-7 mb-1'>
                              {message.time ? getTimeDifference(message.time) : ''}
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className='me-3'>
                            <span className='text-muted fs-7 mb-1'>
                              {message.time ? getTimeDifference(message.time) : ''}
                            </span>
                            <a
                              href='#'
                              className='fs-5 fw-bolder text-gray-900 text-hover-primary ms-1'
                            >
                              {i18n.t(`chat.you`)}
                            </a>
                          </div>
                        </>
                      )}
                    </div>

                    <div
                      className={clsx(
                        'p-5 rounded',
                        `bg-light-${state}`,
                        'text-dark fw-bold mw-lg-400px',
                        `text-${message.type === 'in' ? 'start' : 'end'}`
                      )}
                      data-kt-element='message-text'
                      dangerouslySetInnerHTML={{__html: rtcToText(message.text)}}
                    ></div>
                  </div>
                </div>
              )
            }
          })}
      </div>

      <div
        className={styles.footerChat}
        id={isDrawer ? 'kt_drawer_chat_messenger_footer' : 'kt_chat_messenger_footer'}
      >
        <div className='d-flex flex-stack gap-2 justify-content-between flex-row align-items-end' style={{width: '100%'}}>
          <textarea
            ref={textbox}
            style={{resize: 'none'}}
            className={styles.chatText}
            data-kt-element='input'
            placeholder={i18n.t(`chat.type_message`)}
            value={message}
            onChange={(e) => {
              setMessage(e.target.value)
              adjustHeightTextArea();
            }}
            onKeyDown={onEnterPress}
          ></textarea>
          
          <div className='d-flex align-items-center gap-2'>
            <button
              style={{padding: '0.75em 1.5em'}}
              className='btn btn-primary'
              type='button'
              data-kt-element='send'
              onClick={() => {if(message) sendMessage('out', 1)}}
            >
              {i18n.t(`chat.send`)}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ChatInner}